<template>
    <div class="container container-tabs sub">
        <div class="handle-box-search">
            <div class="handle-box">
                <div v-show="more_query">
                    <div class="table-head table-head-search">
                        <div>
                            <span class="title">乘客电话:</span>
                            <el-input
                                v-model="search_data.consumer_phone"
                                placeholder="请输入乘客电话"
                                maxlength="11"
                                @keyup.enter.native="searchOrderLists"
                            >
                            </el-input>
                        </div>

                        <!-- <div>
                            <span class="title">乘客姓名:</span>
                            <el-input
                                v-model="search_data.consumer_name"
                                placeholder="请输入乘客姓名"
                                @keyup.enter.native="searchOrderLists"
                            >
                            </el-input>
                        </div> -->
                        <div>
                            <span class="title">回访状态:</span>

                            <el-select
                                v-model="search_data.visit_status"
                                placeholder="请选择状态"
                                clearable
                                @keyup.enter.native="searchOrderLists"
                            >
                                <el-option label="已回访" value="1"> </el-option>
                                <el-option label="未回访" value="0"> </el-option>
                            </el-select>
                        </div>
                        <div>
                            <span class="title">司机电话:</span>
                            <el-input
                                v-model="search_data.driver_phone"
                                placeholder="请输入司机电话"
                                maxlength="11"
                                @keyup.enter.native="searchOrderLists"
                            >
                            </el-input>
                        </div>
                    </div>

                    <div class="table-head table-head-search">
                        <div>
                            <span class="title">司机姓名:</span>
                            <el-input v-model="search_data.driver_name" placeholder="请输入司机姓名" @keyup.enter.native="searchOrderLists">
                            </el-input>
                        </div>

                        <div>
                            <span class="title">新老用户:</span>

                            <el-select
                                v-model="search_data.is_new_visit"
                                placeholder="请选择"
                                clearable
                                @keyup.enter.native="searchOrderLists"
                            >
                                <el-option :label="item.alias" :value="item.val" v-for="(item, index) in is_new_visit_array" :key="index">
                                </el-option>
                            </el-select>
                        </div>
                        <div></div>

                    </div>
                </div>

                <el-row type="flex" justify="space-between">
                    <el-col :span="22">
                        <el-button type="primary" icon="el-icon-search" @click="searchOrderLists" style="padding: 6px 12px"
                            >搜索
                        </el-button>
                        <el-button icon="el-icon-refresh" @click="refresh" style="padding: 6px 12px">重置 </el-button>
                    </el-col>
                    <!--                    <el-col :span="2">-->
                    <!--                        <el-button @click="getOrderCount" style="padding: 6px 12px;" type="success" :loading="btn_loading">获取订单数量</el-button>-->
                    <!--                    </el-col>-->
                </el-row>
            </div>
        </div>

        <!-- 表格 -->
        <el-table
            :data="tableData"
            style="width: 100%"
            ref="multipleTable"
            header-cell-class-name="table-header"
            class="order-table-lists"
            @row-contextmenu="rowContextmenu"
        >
            <el-table-column type="expand">
                <template slot-scope="props">
                    <el-form label-position="right" inline class="demo-table-expand">
                        <el-form-item label="订单备注:">
                            <span>{{ props.row.remarks }}</span>
                        </el-form-item>
                    </el-form>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="150" fixed>
                <template slot-scope="scope">
                    <el-dropdown
                        split-button
                        type="primary"
                        trigger="click"
                        @click="viewRoute(scope.row.order_code, scope.row.status.val)"
                        v-if="search_data.status != 'order_cancel'"
                    >
                        查看

                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="salesOrder(scope.row.order_code)"> 销单 </el-dropdown-item>

                            <el-dropdown-item
                                @click.native="
                                    toAppend(
                                        scope.row.order_code,
                                        scope.row.city.name,
                                        scope.row.start_coordinate,
                                        scope.row.order_mode.order_mode_code
                                    )
                                "
                            >
                                追加订单
                            </el-dropdown-item>

                            <el-dropdown-item
                                @click.native="orderPayment(scope.row.order_code, scope.row.amount)"
                                v-if="scope.row.status.val == '7' || scope.row.status.val == '8' || scope.row.status.val == '9'"
                            >
                                订单支付
                            </el-dropdown-item>

                            <el-dropdown-item
                                @click.native="
                                    transferOrder(
                                        scope.row.order_code,
                                        scope.row.city.name,
                                        scope.row.start_coordinate,
                                        scope.row.order_mode.order_mode_code
                                    )
                                "
                                v-if="scope.row.status.val == '14' || scope.row.status.val == '0'"
                            >
                                协助指派
                            </el-dropdown-item>

                            <el-dropdown-item
                                @click.native="orderBack(scope.row.order_code, scope.row.status.val)"
                                v-if="
                                    scope.row.status.val == '2' ||
                                    scope.row.status.val == '3' ||
                                    scope.row.status.val == '4' ||
                                    scope.row.status.val == '5' ||
                                    scope.row.status.val == '6'
                                "
                            >
                                订单收回
                            </el-dropdown-item>

                            <el-dropdown-item
                                @click.native="visitOrder(scope.row.order_code, scope.row.visit_status.val, scope.row.consumer_phone)"
                            >
                                订单回访
                            </el-dropdown-item>

                            <el-dropdown-item @click.native="editOrder(scope.row.order_code)"> 订单修改 </el-dropdown-item>

                            <el-dropdown-item @click.native="orderAssess(scope.row.order_code)"> 订单评价 </el-dropdown-item>

                            <el-dropdown-item @click.native="toCoupon(scope.row.order_code)"> 查看订单所用优惠券 </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>

                    <el-button type="primary" @click="viewRoute(scope.row.order_code)" v-else>查看</el-button>
                </template>
            </el-table-column>

            <el-table-column prop="status.alias" label="订单状态" fixed width="180">
                <template slot-scope="scope">
                    <span
                        v-if="scope.row.status.val == 0"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(222, 163, 45, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(222, 163, 45);
                            border: 1px solid rgb(222, 163, 45);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 1"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(130, 85, 159, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(130, 85, 159);
                            border: 1px solid rgb(130, 85, 159);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 2"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(69, 185, 124, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(69, 185, 124);
                            border: 1px solid rgb(69, 185, 124);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 3"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(1, 107, 84, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(1, 107, 84);
                            border: 1px solid rgb(1, 107, 84);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 4"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(253, 175, 23, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(253, 175, 23);
                            border: 1px solid rgb(253, 175, 23);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 5"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(244, 130, 33, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(244, 130, 33);
                            border: 1px solid rgb(244, 130, 33);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 6"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(178, 67, 74, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(178, 67, 74);
                            border: 1px solid rgb(178, 67, 74);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 7"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(250, 167, 84, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(250, 167, 84);
                            border: 1px solid rgb(250, 167, 84);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 8"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(132, 57, 0, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(132, 57, 0);
                            border: 1px solid rgb(132, 57, 0);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 9"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(127, 185, 15, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(127, 185, 15);
                            border: 1px solid rgb(127, 185, 15);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 10"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(170, 34, 22, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(170, 34, 22);
                            border: 1px solid rgb(170, 34, 22);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 11"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(199, 60, 39, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(199, 60, 39);
                            border: 1px solid rgb(199, 60, 39);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 12"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(111, 109, 133, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(111, 109, 133);
                            border: 1px solid rgb(111, 109, 133);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 13"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(0, 138, 143, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(0, 138, 143);
                            border: 1px solid rgb(0, 138, 143);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 14"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(1, 173, 159, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(1, 173, 159);
                            border: 1px solid rgb(1, 173, 159);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 15"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(114, 119, 123, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(114, 119, 123);
                            border: 1px solid rgb(114, 119, 123);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 16"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(244, 112, 74, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(244, 112, 74);
                            border: 1px solid rgb(244, 112, 74);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 17"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(241, 90, 35, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(241, 90, 35);
                            border: 1px solid rgb(241, 90, 35);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 18"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(94, 124, 135, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(94, 124, 135);
                            border: 1px solid rgb(94, 124, 135);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 19"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(61, 55, 69, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(61, 55, 69);
                            border: 1px solid rgb(61, 55, 69);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 20"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(29, 149, 60, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(29, 149, 60);
                            border: 1px solid rgb(29, 149, 60);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 21"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(29, 149, 60, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(29, 149, 60);
                            border: 1px solid rgb(29, 149, 60);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 40"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(89, 19, 60, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(89, 19, 60);
                            border: 1px solid rgb(89, 19, 60);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="order_source" fixed label="订单渠道" width="180">
                <template slot-scope="scope">
                    <span
                        v-if="scope.row.order_source != '' && scope.row.order_source != null"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(255, 0, 45, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(255, 90, 45);
                            border: 1px solid rgb(255, 90, 45);
                        "
                    >
                        {{ scope.row.order_source }}</span
                    >
                </template>
            </el-table-column>

            <!-- <el-table-column prop="consumer_phone" label="乘客电话(金色为VIP)" width="180" fixed>
                <template slot-scope="scope">

                    <span :class="{ vip: scope.row.consumer_vip.val == '1', groupName: scope.row.consumer.group_wallet_code != ''}"

                        >{{ scope.row.consumer_phone }}
                        <el-button
                            class="el-icon-search"
                            style="padding: 8px 8px"
                            @click="
                                visitHistory_isShow = !visitHistory_isShow;
                                visitHistory_data = scope.row.order_code;
                            "
                        ></el-button>
                    </span>
                </template>
            </el-table-column> -->
            <!-- 黑色是普通用户，金色是VIP用户，绿色是集团，混色是VIP+集团 -->
            <!-- vip: scope.row.consumer_vip.val == '1'
            groupName: scope.row.consumer.group_wallet_code != ''
            vip + groupName: scope.row.consumer.group_wallet_code != '' && scope.row.consumer_vip.val == '1' -->

            <!--    vip ==1    consumer.group_wallet_code ==' '  是vip 不是集团  前vip 后vip

                    vip ==1    consumer.group_wallet_code !=' '    是vip  是集团  前vip 后groupName

                    vip ==0    consumer.group_wallet_code !=' '    不是vip 是集团  前groupName 后groupName

                    vip ==0    consumer.group_wallet_code ==' '  不是vip 不是集团 前黑色 后黑色 -->

            <!-- <el-table-column prop="" fixed label="" width="180px">
                <template slot="header" slot-scope="scope">
                    乘客电话
                    <el-popover
                        placement="top-start"
                        title=""
                        width="400"
                        trigger="hover"
                        content="黑色是普通用户，金色是VIP用户，绿色是集团，金色+绿色是“VIP+集团”用户"
                    >
                        <i class="el-icon-question" slot="reference"></i>
                    </el-popover>
                </template>
                <template slot-scope="scope">
                    <span
                        :class="{
                            vip: scope.row.consumer_vip.val == '1',

                            groupName: scope.row.consumer_vip.val == '0' && scope.row.consumer.group_wallet_code != ''
                        }"
                        >{{ scope.row.consumer_phone.slice(0, 3) }} ***</span
                    >
                    <span
                        :class="{
                            vip: scope.row.consumer_vip.val == '1' && scope.row.consumer.group_wallet_code == '',
                            groupName: scope.row.consumer.group_wallet_code != ''
                        }"
                        >*{{ scope.row.consumer_phone.slice(7, 11) }}
                    </span>
                    <el-button
                        class="el-icon-search"
                        style="padding: 8px 8px"
                        @click="
                            visitHistory_isShow = !visitHistory_isShow;
                            visitHistory_data = scope.row.order_code;
                        "
                    ></el-button>
                </template>
            </el-table-column> -->
            <el-table-column prop="" fixed label="" width="180px">
                <template slot="header" slot-scope="scope">
                    乘客电话
                    <el-popover
                        placement="top-start"
                        title=""
                        width="400"
                        trigger="hover"
                        content="黑色是普通用户，金色是VIP用户，绿色是集团，金色+绿色是“VIP+集团”用户"
                    >
                        <i class="el-icon-question" slot="reference"></i>
                    </el-popover>
                </template>
                <template slot-scope="scope">
                    <span
                        :class="{
                            vip: scope.row.consumer_vip.val == '1',
                            groupName:
                                scope.row.consumer_vip.val == '0' &&
                                scope.row.consumer.group_wallet_code != '' &&
                                scope.row.consumer.group_wallet_code
                        }"
                        >{{ scope.row.consumer_phone.slice(0, 7) }}</span
                    >
                    <span
                        :class="{
                            vip:
                                scope.row.consumer_vip.val == '1' &&
                                scope.row.consumer.group_wallet_code &&
                                scope.row.consumer.group_wallet_code == '',
                            groupName: scope.row.consumer.group_wallet_code != '' && scope.row.consumer.group_wallet_code
                        }"
                        >{{ scope.row.consumer_phone.slice(7, 11) }}
                    </span>
                    <el-button
                        class="el-icon-search"
                        style="padding: 8px 8px"
                        @click="
                            visitHistory_isShow = !visitHistory_isShow;
                            visitHistory_data = scope.row.order_code;
                        "
                    ></el-button>
                </template>
            </el-table-column>

            <el-table-column prop="order_time.YmdHis" label="下单时间" width="220"> </el-table-column>

            <el-table-column prop="start_name" label="起点名称" width="400"> </el-table-column>

            <el-table-column prop="consumer_name" label="乘客姓名" width="250">
                <template slot-scope="scope">
                    <span type="text" style="font-size: 16px">
                        {{ scope.row.consumer_name }}

                        <el-button class="el-icon-search" style="padding: 8px 8px" @click="toConsumer(scope.row.consumer_code)"></el-button>
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="consumer_name" label="强制大厅" min-width="100">
                <template slot-scope="scope">
                    <span type="text" style="font-size: 16px">
                        <span
                        v-if="scope.row.scan_order.val == 3"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(69, 185, 124, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(69, 185, 124);
                            border: 1px solid rgb(69, 185, 124);
                        "
                        >
                            厅
                        </span>
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="driver_verify.real_name" label="司机姓名" width="180">
                <template slot-scope="scope">
                    <span type="text" style="font-size: 16px">
                        {{ scope.row.driver_verify == null ? '' : scope.row.driver_verify.real_name }}

                        <el-button
                            class="el-icon-search"
                            style="padding: 8px 8px"
                            @click="toDriver(scope.row.driver_code)"
                            v-if="scope.row.driver_verify.real_name != undefined"
                        ></el-button>
                    </span>
                </template>
            </el-table-column>

            <el-table-column prop="driver_phone" label="司机电话" width="150"> </el-table-column>

            <el-table-column prop="visit_status.alias" label="回访状态" width="150"> </el-table-column>

            <el-table-column label="新老用户" width="150">
                <template slot-scope="scope">
                    {{ scope.row.is_new_visit.alias }}
                </template>
            </el-table-column>

            <el-table-column prop="end_name" label="终点名称" width="400"> </el-table-column>
            <el-table-column prop="order_type.alias" label="订单类型" width="220"> </el-table-column>
            <el-table-column prop="platform.alias" label="订单来源" width="200">
                <template slot-scope="scope">
                    {{ scope.row.platform.alias }}
                </template>
            </el-table-column>

            <el-table-column prop="platform.alias" label="端口" width="200">
                <template slot-scope="scope">
                    {{ scope.row.port.alias }}
                </template>
            </el-table-column>

            <el-table-column prop="city.name" label="所属城市" width="150">
                <template slot-scope="scope">
                    <el-button type="text" @click="toCity(scope.row.city.city_code)" style="font-size: 16px">
                        {{ scope.row.city.name }}
                    </el-button>
                </template>
            </el-table-column>

            <el-table-column label="订单模式" width="150">
                <template slot-scope="scope">
                    <el-button type="text" @click="toIframe(scope.row.order_mode.order_mode_code)" style="font-size: 16px">
                        {{ scope.row.order_mode.name }}
                    </el-button>
                </template>
            </el-table-column>

            <el-table-column prop="predict_amount" label="预估金额" width="100"> </el-table-column>

            <el-table-column prop="amount" label="实际金额" width="100"> </el-table-column>

            <el-table-column prop="finish_amount" label="实收金额" width="100"> </el-table-column>

            <el-table-column prop="pay_mode.alias" label="支付方式" width="100"> </el-table-column>

            <el-table-column prop="pay_channel.alias" label="付款通道" width="100"> </el-table-column>

            <el-table-column label="评价状态" width="150">
                <template slot-scope="scope">
                    {{ scope.row.appraise_status == '1' ? '已评价' : '未评价' }}
                </template>
            </el-table-column>
            <el-table-column prop="consumer_vip.alias" label="乘客类型" width="180"> </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>

        <!-- 查看组件 -->
        <viewRoute :isShow="viewRoute_show" :data="toDispatch_data" :status="order_status" :showConsumer="true"></viewRoute>

        <!-- <toDispatch :isShow="toDispatch_isShow" @onSubmit="orderLists" :data="toDispatch_data"></toDispatch> -->

        <!-- 销单组件 -->
        <salesOrder :isShow="salesOrder_show" @onSubmit="orderLists" :data="toDispatch_data"></salesOrder>

        <el-dialog :visible.sync="iframe_show" width="600px">
            <iframeModel :isShow="iframe_show" :param="iframe_param" :iframe_url="iframe_url" style="height: 60vh"> </iframeModel>

            <div style="text-align: center">
                <el-button @click="iframe_show = false" class="close-btn">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 编辑司机组件 -->
        <editDriverDrawer :isShow="edit_driver_isShow" :data="driver_code_children"></editDriverDrawer>

        <!-- 编辑乘客组件 -->
        <editConsumer :isShow="edit_consumer_isShow" :data="consumer_code_children" :money="true"></editConsumer>

        <!-- 订单支付组件 -->
        <orderPayment
            :isShow="orderPayment_show"
            :data="orderPayment_data"
            :money="orderPayment_money"
            @onSubmit="orderLists"
        ></orderPayment>

        <!-- 订单回访组件 -->
        <visitOrder
            :isShow="visitOrder_show"
            :data="visitOrder_data"
            :status="visitOrder_status"
            @onSubmit="orderLists"
            :city="visitOrder_city"
            :phone="visitOrder_phone"
        ></visitOrder>

        <!-- 协助指派组件 -->
        <transfer
            :isShow="transferOrder_show"
            :city="transferOrder_city"
            :transferOrder_start="transferOrder_start"
            :order_code="transferOrder_code"
            :order_mode_code="transferOrder_mode_code"
            @tipModelShow="tipModelShow"
            @onSubmit="orderLists"
        >
        </transfer>

        <!-- 订单收回组件 -->
        <orderBack :isShow="orderBack_show" :data="orderBack_data" @onSubmit="orderLists"></orderBack>

        <!-- 表格右键菜单栏组件 -->
        <context-button
            v-if="menuVisible"
            @foo="foo"
            ref="contextbutton"
            @salesOrder="salesOrder"
            :transferOrder_city="transferOrder_city"
            @orderPayment="orderPayment"
            :data="context_data"
            :orderPay="orderPaymentContextmenu_show"
            :orderPayment_money="orderPayment_money"
            @transferOrder="transferOrder"
            @orderBack="orderBack"
            :orderBackMenu_show="orderBackMenu_show"
            :transferOrder_start="transferOrder_start"
            :transferOrderMenu_show="transferOrderMenu_show"
            :order_mode_code="transferOrder_mode_code"
            @toAppend="toAppend"
            :visitOrder_status="visitOrder_status"
            :visitOrder_city="visitOrder_city"
            :visitOrder_phone="visitOrder_phone"
            @visitOrder="visitOrder"
            @editOrder="editOrder"
            @orderAssess="orderAssess"
            @toCoupon="toCoupon"
        >
        </context-button>

        <!-- 追加订单组件 -->
        <append
            :isShow="append_show"
            :data="append_data"
            :city="append_city"
            :transferOrder_start="append_start"
            :order_mode_code="transferOrder_mode_code"
            @tipModelShow="tipModelShow"
            @onSubmit="orderLists"
        >
        </append>

        <tipModel :isShow="tipModel_isShow" :data="tipModel_data" :type_data="tipModel_type"></tipModel>

        <visitHistory :isShow="visitHistory_isShow" :data="visitHistory_data"></visitHistory>

        <editOrder :isShow="editOrder_show" :data="editOrder_data"></editOrder>

        <orderAssess :isShow="orderAssess_show" :data="orderAssess_data"></orderAssess>
    </div>
</template>

<script>
import viewRoute from './viewRoute.vue';
// import toDispatch from './toDispatch.vue';
import salesOrder from './salesOrder.vue';
import orderPayment from './orderPayment.vue';
import iframeModel from '../../../common/iframe.vue';
import editDriverDrawer from '../../driver/editDriverDrawer.vue';
import editConsumer from '../../user/editConsumer.vue';
import contextButton from './contextButton.vue';
import visitOrder from './visitOrder.vue';
import transfer from './transfer.vue';
import append from './append.vue';
import orderBack from './orderBack.vue';
import tipModel from '../tips.vue';
import visitHistory from './visitHistory.vue';
import editOrder from './editOrder.vue';
import orderAssess from './orderAssess.vue';
import { config } from '@/utils/config.js'; //配置
var _this;
export default {
    components: {
        viewRoute,
        // toDispatch,
        salesOrder,
        iframeModel,
        editDriverDrawer,
        editConsumer,
        orderPayment,
        visitOrder,
        transfer,
        contextButton,
        orderBack,
        tipModel,
        append,
        visitHistory,
        editOrder,
        orderAssess
    },
    data() {
        return {
            excelHead: ['司机姓名', '司机电话', '乘客姓名', '乘客电话', '起点名称'],
            // 导出excel表格数据
            excelData: [],

            platform_select_array: [],
            port_select_array: [],
            vip_select_array: [],

            orderAssess_show: false,
            orderAssess_data: '',

            append_show: false,
            append_data: '',
            append_city: '',
            append_start: '',

            btn_loading: false,

            editOrder_show: false,
            editOrder_data: '',

            visitHistory_isShow: false,
            visitHistory_data: '',

            tipModel_isShow: false,
            tipModel_data: '',
            tipModel_type: '',

            menuVisible: false,

            orderBack_show: false,
            orderBack_data: '',

            orderPaymentContextmenu_show: true,
            orderBackMenu_show: true,

            // 右键菜单栏需要的code
            context_data: '',

            transferOrder_show: false,
            transferOrder_city: '',
            transferOrder_start: '',
            transferOrder_code: '',
            transferOrder_mode_code: '',
            transferOrderMenu_show: false,

            visitOrder_show: false,
            visitOrder_data: '',
            visitOrder_status: '',
            visitOrder_city: '',
            visitOrder_phone: '',

            orderPayment_show: false,
            orderPayment_data: '',
            orderPayment_money: '',

            edit_consumer_isShow: false,
            consumer_code_children: '',

            // 传给查看组件的订单状态
            order_status: '',

            // 每种状态的总数
            order_number: '',

            edit_driver_isShow: false,
            driver_code_children: '',

            edit_isShow: false,
            edit_dialog_data: '',

            iframe_show: false,
            iframe_url: '',
            iframe_param: '',

            // 预约自定义时间
            order_time_arrway: [],

            //完成自定义时间
            complete_time_arrway: [],

            is_new_visit_array: [],

            // 查看路线开关
            viewRoute_show: false,

            // 销单开关
            salesOrder_show: false,

            more_query: true,

            order_fixed_time_value: '',

            complete_fixed_time_value: '',

            // 派单组件显示开关
            toDispatch_isShow: false,

            // 派单组件数据
            toDispatch_data: '',

            // 追加组件数据
            append_data: '',

            // 选项卡默认选中项
            activeName: '',

            // 下拉搜索管理状态
            value_status_code: '',
            value_status_array: [],

            // 下拉搜索模式
            value_mode_code: '',
            options_mode_code: [],
            mode_options_data: {
                page: 1,
                limit: 5,
                status: '1'
            },

            delDriverSubmit_rules: {
                driver_code_array: {
                    placeholder: '权限模块',
                    rules: {
                        required: false,
                        message: '权限模块代码数组(json)',
                        regulation: 'special',
                        rulesData: 'json_array'
                    }
                }
            },

            // 存放表格数据
            tableData: [],

            //翻页数据
            search_data: {
                page: 1,
                limit: 10,
                status: 'new',
                consumer_name: '',
                consumer_phone: '',
                driver_phone: '',
                driver_name: '',
                is_new_visit: '',
                visit_status: ''
            },

            selectPages_data: [],

            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;

        _this.iframe_url = config.h5;

        if (_this.$route.query.order_code) {
            _this.search_data.order_code = _this.$route.query.order_code;
        }

        _this.orderLists();
    },

    methods: {
        toCoupon(code) {
            this.$router.push({
                path: 'couponRecordLists',
                query: {
                    order_code: code
                }
            });
        },
        orderAssess(code) {
            _this.orderAssess_show = !_this.orderAssess_show;
            _this.orderAssess_data = code;
        },
        //订单修改
        editOrder(code) {
            _this.editOrder_show = !_this.editOrder_show;
            _this.editOrder_data = code;
        },

        tipModelShow(msg) {
            _this.tipModel_isShow = !_this.tipModel_isShow;
            _this.tipModel_data = msg;
            _this.tipModel_type = 'success';
        },

        orderBack(code, status) {
            _this.orderBack_show = !_this.orderBack_show;
            _this.orderBack_data = code;
        },

        // 表格右键点击事件
        rowContextmenu(row, column, event) {
            if (row.status.val == '7' || row.status.val == '8' || row.status.val == '9') {
                _this.orderPaymentContextmenu_show = true;
            } else {
                _this.orderPaymentContextmenu_show = false;
            }

            if (row.status.val == '2' || row.status.val == '3' || row.status.val == '4' || row.status.val == '5' || row.status.val == '6') {
                _this.orderBackMenu_show = true;
            } else {
                _this.orderBackMenu_show = false;
            }

            if (row.status.val == '14' || row.status.val == '0') {
                _this.transferOrderMenu_show = true;
                _this.transferOrder_mode_code = row.order_mode.order_mode_code;
            } else {
                _this.transferOrderMenu_show = false;
            }

            _this.visitOrder_status = row.visit_status.val;
            _this.visitOrder_phone = row.consumer_phone;

            _this.orderPayment_money = row.amount;

            _this.context_data = row.order_code;
            _this.transferOrder_start = row.start_coordinate;

            if (this.menuVisible) {
                this.menuVisible = false;

                setTimeout(() => {
                    this.menuVisible = true;

                    this.$nextTick(() => {
                        this.$refs.contextbutton.init(row, column, event);
                    });
                }, 1);
            } else {
                this.menuVisible = true;

                this.$nextTick(() => {
                    this.$refs.contextbutton.init(row, column, event);
                });
            }

            // 阻止右键默认行为
            event.preventDefault();
        },

        foo() {
            // 取消鼠标监听事件 菜单栏
            this.menuVisible = false;
            document.removeEventListener('click', this.foo);
        },

        transferOrder(code, city, start_coordinate, order_mode_code) {
            _this.transferOrder_show = !_this.transferOrder_show;

            _this.transferOrder_code = code;
            _this.transferOrder_mode_code = order_mode_code;

            _this.transferOrder_city = city;
            _this.transferOrder_start = start_coordinate;
        },

        visitOrder(code, visit_status, phone) {
            _this.visitOrder_show = !_this.visitOrder_show;
            _this.visitOrder_data = code;
            _this.visitOrder_status = visit_status;
            _this.visitOrder_city = city;
            _this.visitOrder_phone = phone;
        },

        orderPayment(code, money) {
            _this.orderPayment_show = !_this.orderPayment_show;
            _this.orderPayment_data = code;
            _this.orderPayment_money = money;
        },

        toDriver(code) {
            _this.driver_code_children = code;
            _this.edit_driver_isShow = !_this.edit_driver_isShow;
        },

        toConsumer(code) {
            _this.consumer_code_children = code;
            _this.edit_consumer_isShow = !_this.edit_consumer_isShow;
        },

        toCity(code) {
            _this.edit_dialog_data = code;
            _this.edit_isShow = !_this.edit_isShow;
        },

        toIframe(code) {
            _this.iframe_param = code;
            _this.iframe_show = true;
        },

        searchOrderLists() {
            _this.search_data.page = 1;
            _this.orderLists();
        },

        // 销单按钮
        salesOrder(code) {
            _this.salesOrder_show = !_this.salesOrder_show;

            _this.toDispatch_data = code;
        },

        // 重置按钮
        refresh() {
            _this.search_data = {
                page: 1,
                limit: 10,
                status: 'new',
                consumer_name: '',
                consumer_phone: '',
                driver_phone: '',
                driver_name: '',
                is_new_visit: '',
                visit_status: ''
            };
        },

        // 查看按钮方法
        viewRoute(code, status) {
            _this.viewRoute_show = !_this.viewRoute_show;

            _this.toDispatch_data = code;

            _this.order_status = status;
        },

        toAppend(code, city, start_coordinate, order_mode_code) {
            _this.append_show = !_this.append_show;
            _this.append_data = code;
            _this.append_city = city;
            _this.append_start = start_coordinate;
            _this.transferOrder_mode_code = order_mode_code;
        },

        modeChange(val) {
            _this.search_data.order_mode_code = val;
        },

        selectPages_function(search_data) {
            _this.mode_options_data = search_data;

            _this.orderModeList();
        },

        // 选项卡选中事件
        handleClick(tab, event) {
            _this.search_data.status = tab.name;

            _this.search_data.page = 1;

            _this.orderLists();
        },
        getOrderCount() {
            _this.btn_loading = true;
            // 获取每个状态的总数
            _this
                .$post('/order/getOrderCount', {
                    order_fixed_array: _this.search_data.order_fixed_array,
                    complete_fixed_array: _this.search_data.complete_fixed_array,
                    consumer_phone: _this.search_data.consumer_phone,
                    driver_phone: _this.search_data.driver_phone,
                    type: '1'
                })
                .then((res) => {
                    _this.order_number = res.data;
                    _this.btn_loading = false;
                })
                .catch((err) => {});
        },

        // 搜索订单列表
        orderLists() {
            _this.tableData = [];

            _this
                .$post('/order/orderPdLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    console.log(_this.is_new_visit_array);

                    _this.tableData = res.data;
                    _this.result_data = res;

                    _this.is_new_visit_array = res.data[0].is_new_visit.select_array;

                    // console.log(_this.tableData[0].platform);
                })
                .catch((err) => {});
        },

        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.orderLists();
        }
    }
};
</script>

<style scoped>
.handle-select {
    width: 120px;
}

.handle-input {
    width: 200px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-form-item.el-form-item--small {
    width: 100%;
}

.demo-table-expand {
    font-size: 0;
}

.demo-table-expand label {
    width: 90px;
    color: #99a9bf;
}

.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
}

.el-form-item__content span {
    display: inline-block;
    width: 100%;
    word-wrap: break-word;
    white-space: normal;
}

.table-head {
    margin-bottom: 20px;
}

.table-head > div {
    width: 25%;
}

.table-head > div .title {
    display: block;
    width: 100px;
    padding-right: 16px;
    text-align: right;
    box-sizing: border-box;
    color: #606266;
    height: 28px;
    line-height: 28px;
    float: left;
}

.table-head-search {
    display: flex;
    justify-content: space-between;
}

.table-head .search-radio {
    width: 100%;
}

.container-tabs .el-tabs__item.is-top.is-active {
    border: 1px solid #dcdfe6;
}

.vip {
    color: goldenrod;
}
</style>



<style>
.fs-big .el-radio__label {
    font-size: 14px !important;
    font-weight: 500;
    color: #000;
}
.table-head-search .el-select.el-select--small,
.table-head .el-radio-group {
    width: calc(100% - 100px);
}

.table-head-search .el-select.el-select--small .el-input.el-input--small.el-input--suffix {
    width: 100% !important;
}

.table-head > div .el-input--small {
    width: calc(100% - 100px);

    float: left;
}

.table-head > div .el-input--small .el-input__inner {
    height: 28px;
    line-height: 28px;
}

.container .el-tabs__header {
    margin-bottom: 0 !important;
}

.table-head .el-checkbox__inner {
    display: none;
}

.table-head .el-radio__inner {
    display: none;
}

.table-head .el-checkbox-group {
    display: inline-block;
}

.table-head .el-checkbox,
.table-head .el-radio {
    border: 0px solid transparent;
    background-color: transparent;
    border-radius: 5px !important;
}

.table-head .el-checkbox.is-checked,
.table-head .el-radio.is-checked {
    border: 0px solid #409eff;
    /* background-color: #ecf5ff;  */
}

.table-head .el-checkbox__label,
.table-head .el-radio__label {
    padding: 0;
}

.container-tabs .el-tabs__nav.is-top {
    border: 0;
}

.container-tabs .el-tabs__item.is-top {
    border: 1px solid transparent;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
}

.container-tabs .el-tabs__header.is-top {
    border-bottom: 0;
}

.el-col.el-col-6 > span {
    display: inline-block;
    width: 100px;
    text-align: left;
}

.sub #tab-new .table-title {
    color: #65c138;
}

.sub #tab-proceed .table-title {
    color: #b6ae3a;
}

.sub #tab-serving .table-title {
    color: #409eff;
}

.sub #tab-unpaid .table-title {
    color: #f67745;
}

.sub #tab-paid .table-title {
    color: #606266;
}

.sub #tab-order_cancel .table-title {
    color: #606266;
}

.order-table-lists .el-table__body .cell {
    color: #000;
    font-weight: 500;
    font-size: 18px;
}

.el-date-range-picker__time-header {
    display: block;
}
</style>
